import { apiSlice } from "./apiSlice";
import {QUIZ_QUESTION_URL } from "../constants";

export const quizQuestionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create Quiz Question
    createQuizQuestion: builder.mutation({
      query: (data) => ({
        url:QUIZ_QUESTION_URL,
        method: "POST",
        body: data,
      }),

      invalidatesTags: ["QuizQuestion"],
    }),

    // Get All Questions of a Quiz
    getQuizQuestions: builder.query({
      query: (quizId) => ({
        url: `${QUIZ_QUESTION_URL}/quiz/${quizId}`,
      }),

      providesTags: ["QuizQuestion"],

      keepUnusedDataFor: 5,
    }),

    // Get Quiz Question Details
    getQuizQuestionDetails: builder.query({
      query: (id) => ({
        url: `${QUIZ_QUESTION_URL}/${id}`,
      }),

      providesTags: ["QuizQuestion"],

      keepUnusedDataFor: 5,
    }),

    // Update Quiz Question
    updateQuizQuestion: builder.mutation({
      query: (data) => ({
        url: `${QUIZ_QUESTION_URL}/${data.quizQuestionId}`,
        method: "PUT",
        body: data,
      }),

      invalidatesTags: ["QuizQuestion"],
    }),

    // Delete Quiz Question
    deleteQuizQuestion: builder.mutation({
      query: (id) => ({
        url: `${QUIZ_QUESTION_URL}/${id}`,
        method: "DELETE",
      }),

      invalidatesTags: ["QuizQuestion"],
    }),
  }),
});

export const {
  useCreateQuizQuestionMutation,

  useGetQuizQuestionsQuery,

  useGetQuizQuestionDetailsQuery,

  useUpdateQuizQuestionMutation,

  useDeleteQuizQuestionMutation,
} = quizQuestionApiSlice;
